import React, { Component } from 'react'
import { Carousel } from "react-bootstrap";
import BannerCarouselButton from "./banner-carousel-button";

import './banner-carousel.css';

class BannerCarousel extends Component {

  componentDidMount() {
    this.updateCssVars();
  }

  updateCssVars() {
    const { carousels } = this.props;
    carousels.forEach((carousel, key) => {
      if (!this.refs[`carouselItem${key}`]) return;
  
      this.refs[`carouselItem${key}`].style.setProperty('--carousel-text-color', carousel['text_color'] || '#000000');
    });
  }

  render() {
    const { carousels, carouselSpeed } = this.props;


    return (
      <div>
        <Carousel interval={carouselSpeed * 1000} indicators={carousels.length > 1} controls={carousels.length > 1} className='banner-carousel-container'>
          {carousels.map((carousel, key) => {
            const refName = `carouselItem${key}`;
            
            return (
            <Carousel.Item key={key}>
              {carousel.image_uid && carousel.image_uid.endsWith('.mp4') ? (
                <video className="carousel-image video" loop autoPlay>
                  <source src={carousel.link.image}
                          type="video/mp4"></source>
                  Sorry, your browser doesn't support videos.
                </video>
              ) : (
                <img className="carousel-image" alt={carousel.title || 'carousel-background'}
                     src={carousel.link.image}/>
              )}
              <Carousel.Caption className="carousel-caption-banner">
                <div className="carousel-details-container">
                  <div ref={refName} className="carousel-text-container">
                    {carousel['title'] &&
                      <h1 className='carousel-title carousel-text-color'>{carousel.title || ' '}</h1>
                    }
                    <p className='carousel-details carousel-text-color'>{carousel.text || ' '}</p>
                  </div>
                  {carousel.button_label &&
                    <BannerCarouselButton
                      buttonColor={carousel.button_color}
                      buttonTextColorWhenHover={carousel.button_text_color_when_hover}
                      buttonLink={carousel.button_link}
                      buttonLabel={carousel.button_label}
                      key={key}
                    />
                  }
                </div>
              </Carousel.Caption>
            </Carousel.Item>
          )})}
        </Carousel>
      </div>
    )
  }
}

export default BannerCarousel;



// WEBPACK FOOTER //
// ./src/components/home/banner-carousel/banner-carousel.jsx